/**
 * Softeq Development Corporation
 * https://www.softeq.com
 */

import { Observable } from 'rxjs';
import { scan, map, distinctUntilChanged } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Quote } from './quote.interface';

@Injectable()
export class QuoteService {
  constructor(private http: HttpClient) {
  }

  public getQuote(): Observable<Quote> {
    const quotes$ = this.http.get<Quote[]>('/assets/data/quotes.json');
    return quotes$.pipe(
      scan((acc, curr) => [...acc, ...curr], []),
      map((quotes) => quotes[Math.floor(Math.random() * quotes.length)]),
      distinctUntilChanged(),
    );
  }
}
